import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { Link, Accordion, AccordionItem } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { Icon } from '@grandvisionhq/icons';
import { useIntl, useSelector } from '@grandvisionhq/state';
import BillingAddressContainer from './components/BillingAddress/BillingAddressContainer.js';
import PersonalDetailsContainer from './components/PersonalDetails/PersonalDetailsContainer.js';
import PersonalGreeting from './components/PersonalGreeting/PersonalGreeting.js';
import PreferredStoreContainer from './components/PreferredStore/PreferredStoreContainer.js';
import RecentOrders from './components/RecentOrders/RecentOrders.js';
import Support from './components/Support/Support.js';
import UpcomingAppointments from './components/UpcomingAppointments/UpcomingAppointments.js';
import { useProfileSections } from './context/ProfileSectionsContext.js';

const Profile = ({ isAABEnabled , showOrderDate  })=>{
    var ref;
    const { href: settingsRoute  } = (ref = useLink({
        route: 'me.settings'
    })) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const { href: ordersRoute  } = (ref1 = useLink({
        route: 'me.orders'
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { subscriptionSection  } = useProfileSections();
    const intl = useIntl();
    const authType = useSelector(Selectors.getAuthType);
    const disableAddressEditing = useSelector(Selectors.getDisableAddressEditing);
    if (authType !== 'regular') {
        throw new Error(`Can't look at the Profile page with passwordless login`);
    }
    const getProfileSections = ()=>{
        const sections = [];
        const openSections = [
            'orders'
        ];
        // creating sections-array for myProfile
        if (isAABEnabled) {
            sections.push({
                key: 'appointments',
                title: intl.getLabel('account.appointments.title'),
                body: /*#__PURE__*/ React.createElement(UpcomingAppointments, null)
            });
            openSections.push('appointments');
        }
        //some opco do not have e-comm yet, so skip orders section
        if (ordersRoute) {
            sections.push({
                key: 'orders',
                title: intl.getLabel('account.profile.recentOrders.title'),
                body: /*#__PURE__*/ React.createElement(RecentOrders, {
                    showOrderDate: showOrderDate
                })
            });
        }
        if (subscriptionSection) {
            sections.push(swcHelpers.objectSpread({
                key: 'subscriptions'
            }, subscriptionSection));
            openSections.push('subscriptions');
        }
        if (!disableAddressEditing) {
            sections.push({
                key: 'billingAddress',
                title: intl.getLabel('account.billingAddress'),
                body: /*#__PURE__*/ React.createElement(BillingAddressContainer, null)
            });
        }
        sections.push({
            key: 'personalDetails',
            title: intl.getLabel('account.profile.personalDetails'),
            body: /*#__PURE__*/ React.createElement("div", {
                className: "myaccount-profile__personal-details"
            }, /*#__PURE__*/ React.createElement(PersonalDetailsContainer, {
                showIntro: true
            }), /*#__PURE__*/ React.createElement(Link, {
                href: settingsRoute
            }, intl.getLabel('account.profile.personalDetails.link'), /*#__PURE__*/ React.createElement(Icon, {
                className: "myaccount-profile__personal-details__icon",
                name: "chevron-right"
            })))
        }, {
            key: 'preferredStore',
            title: intl.getLabel('account.profile.preferredStore'),
            body: /*#__PURE__*/ React.createElement("div", {
                className: "section__body preferred-store"
            }, /*#__PURE__*/ React.createElement(PreferredStoreContainer, null))
        });
        return /*#__PURE__*/ React.createElement(Accordion, null, sections.map((section, i)=>/*#__PURE__*/ React.createElement(AccordionItem, {
                key: section.key,
                id: section.title.replace(' ', '-'),
                label: section.title,
                expanded: openSections.includes(section.key)
            }, section.body)
        ), /*#__PURE__*/ React.createElement(Support, null));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-profile"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, /*#__PURE__*/ React.createElement(PersonalGreeting, null)), /*#__PURE__*/ React.createElement(Text, null, intl.getLabel('account.profile.intro')), getProfileSections());
};

export { Profile, Profile as default };
//# sourceMappingURL=Profile.js.map
